<template>
  <v-card
    elevation="0"
  >
    <v-data-table
      fixed-header
      height="300"
      v-model="selected"
      :headers="headers"
      :items="patients"
      single-select
      show-select
      @item-selected="itemSelected"
      :footer-props="{
        'items-per-page-options': rowsPerPageItems
      }"
      :items-per-page="5"
      :loading="isSearching"
    >
      <template v-slot:top>
        <v-row>
          <v-col>
            <v-text-field
              v-model="caseNumber"
              label="Case Number"
              hide-details
              outlined
              dense
              @focus="patientIdNumber = null"
            ></v-text-field>
          </v-col>
          <!-- <v-col>
            <v-text-field
              v-model="patientIdNumber"
              label="Patient ID Number"
              hide-details
              outlined
              dense
              @focus="caseNumber = null"
            ></v-text-field>
          </v-col> -->
          <v-col>
            <v-btn
              rounded
              depressed
              color="primary"
              @click="search"
            >
              Search
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.options`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              @click="view(item)"
              v-on="on"
              v-bind="attrs"
            >
              mdi-dots-horizontal
            </v-icon>
          </template>
          <span>View Details</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  export default {
    name: 'PatientSearch',

    data: () => ({
      isSearching: false,
      rowsPerPageItems: [5, 10, 20],
      page: 1,
      caseNumber: '', //CAS-157107-M5F6J2, CAS-01563-X1P7H9, CAS-01645-H4W8M5, CAS-01732-N4R0V9
      patientIdNumber: '',
      selected: [],
      headers: [
        {
          text: 'Case Number',
          align: 'start',
          sortable: true,
          value: 'CaseNumber',
        },
        // {
        //   text: 'Member ID',
        //   align: 'start',
        //   sortable: true,
        //   value: 'MemberId',
        // },
        {
          text: 'Full Name',
          align: 'start',
          sortable: true,
          value: 'FullName',
        },
        { text: 'Patient ID', value: 'PatientId' },
        { text: 'Email Address', value: 'Email' },
        { text: '', value: 'options', sortable: false }
      ]
    }),

    computed: {
      patients() {
        let patients = this.$store.getters['pms/patients'];

        if (patients.length) {
          console.log({ patients })
          return patients.map((item) => {
            console.log({ item })
            return {
              CaseTitle: item.CaseTitle,
              CaseNumber: item.CaseNumber,
              FullName: item.PatientDetails.FullName,
              PatientId: item.PatientDetails.PatientId,
              Email: item.PatientDetails.Email,
              Birthdate: item.PatientDetails.Birthday,
              GenderId: item.PatientDetails.GenderId,
              CivilStatus: item.PatientDetails.CivilStatus,
              AlternativeEmail: item.PatientDetails.AlternativeEmail,
              MobileNumber: item.PatientDetails.MobileNumber,
              HealthInsurance: item.PatientDetails.HealthInsurance,
              Height: item.PatientDetails.Height,
              Weight: item.PatientDetails.Weight,
              LatestMenstruationStartDate: item.PatientDetails.LatestMenstruationStartDate,
              NameOfCompany: item.PatientDetails.NameOfCompany,
              ProviderName: item.PatientDetails.ProviderName,
              Allergies: item.PatientDetails.Allergies,
              Medications: item.PatientDetails.Medications,
              Vices: item.PatientDetails.Vices,
              Illnesses: item.PatientDetails.Illnesses
            };
          });
        }

        return [];
      }
    },

    methods: {
      async search() {
        if (this.caseNumber || this.patientIdNumber) {
          this.isSearching = true
          await this.$store.dispatch('pms/fetchPatients',
            {
              caseNumber: this.caseNumber,
              patientIdNumber: this.patientIdNumber
            });
          this.isSearching = false
        }
      },
      itemSelected(selection) {
        if (selection.value) {
          this.$store.commit('pms/setPatient', selection.item)
          this.$emit('selected', selection.value)
        }
        else {
          this.$store.commit('pms/setPatient', null)
          this.$emit('selected', selection.value)
        }
      },
      view(item) {
        this.$emit('view', item)
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>